import { hexToRGB } from 'cfmoto-utils';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#0B2C82'
    },
    opacity: {
      type: Number,
      default: 1
    },
    onBack: {
      type: Function
    },
    border: {
      type: Boolean,
      default: true
    },
    visibleHeight: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      default: 'default' // default/transprent
    },
    leftIconColor: {
      type: String,
      default: '' // default/transprent
    }
  },
  components: {},
  data() {
    return {
      scrollY: 0,
      scrollHeight: 150
    };
  },
  computed: {
    statusBarRootStyles() {
      if (!this.isApp || !this.visibleHeight) {
        return {
          minHeight: 0,
          maxHeight: 0
        };
      }
      const minHeight = `calc(${window.cfmoto.statusBarHeight()} + 44px)`;
      return {
        minHeight
      };
    },
    statusBarWrapStyles() {
      const paddingTop = `${window.cfmoto.statusBarHeight()}`;
      const minHeight = `calc(${window.cfmoto.statusBarHeight()} + 44px)`;
      return {
        minHeight,
        paddingTop
      };
    },
    alpha() {
      const {
        mode,
        scrollY
      } = this;
      if (mode === 'default') {
        return 1;
      }
      if (mode === 'opacityZero') {
        return 0;
      }
      const opacity = (scrollY > this.scrollHeight ? this.scrollHeight : scrollY) / this.scrollHeight;
      if (scrollY < 10) return opacity;
      return opacity < 0.5 ? 0.5 : opacity;
    },
    rootStyles() {
      const display = this.isApp || this.$slots.right ? `block` : `none`; //app环境||right插槽存在内容
      return {
        display
      };
    },
    wrapStyles() {
      const position = this.isApp ? 'fixed' : 'relative';
      if (this.mode === 'default') {
        const borderBottom = this.border ? `1px solid rgba(13, 46, 131, ${this.alpha})` : undefined;
        return {
          position,
          backgroundColor: this.backgroundColor,
          borderBottom
        };
      }
      const borderBottom = this.border && this.isApp ? `1px solid rgba(13, 46, 131, ${this.alpha})` : 'none';
      const backgroundColor = `rgba(${hexToRGB(this.backgroundColor)},${this.alpha})`;
      return {
        position,
        borderBottom,
        backgroundColor
      };
    },
    backStyles() {
      if (!this.isApp) {
        return {
          opacity: 0
        };
      }
      if (this.mode === 'default') {
        return {
          color: this.backgroundColor === '#0B2C82' || this.backgroundColor === '#0B2C82' ? '#ffffff' : '#006DFF'
        };
      }
      if (this.opacity === 1) {
        return {
          color: this.backgroundColor === '#0B2C82' ? '#ffffff' : '#006DFF'
        };
      }
      let color = this.alpha < 0.5 ? '#006DFF' : '#ffffff';
      const opacity = this.isApp ? 1 : 0; // app环境
      color = this.leftIconColor ? this.leftIconColor : color;
      return {
        opacity,
        color
      };
    },
    titleStyles() {
      if (this.mode === 'default') {
        return {
          color: '#ffffff'
        };
      }
      if (this.opacity === 1) {
        return {
          color: '#ffffff'
        };
      }
      const color = this.alpha < 0.5 ? 'rgba(255,255,255,0)' : '#ffffff';
      const opacity = !this.isApp || this.alpha < 0.5 ? 0 : 1; // 非app环境||自定义背景色
      return {
        color,
        opacity
      };
    },
    rightStyles() {
      const color = this.alpha < 0.5 ? '#006DFF' : '#ffffff';
      const display = this.$slots.right ? 'block' : 'none'; //如果right插槽存在内容
      return {
        display,
        color
      };
    }
  },
  methods: {
    async handleBack() {
      if (this.onBack) {
        await this.onBack();
      }
      this.$router.back();
    },
    onPageScroll(e) {
      this.scrollY = e.target.scrollTop || document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0;
      // this.scrollY = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0;
    }
  },
  created() {},
  mounted() {
    window.addEventListener('scroll', this.onPageScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onPageScroll);
  },
  watch: {}
};